// extracted by mini-css-extract-plugin
export default {"grid":"DtgSbZ","container":"S4AAp6","column":"_6WS4a_","row":"Gv211h"};